<div class="soe-title">
  <p>SILVIA ORDOVÁS</p>
  <span>PHOTOGRAPHY</span>
</div>
